import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Alert, LinearProgress } from '@mui/material'
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined'
import PageTitle from '../../../components/PageTitle'
import { KpiRow, Pill, SectionCard, ActionIconBtn } from '../components/common'
import DataTable from '../components/Tables'
import { PATHS } from '../constants'
import { useListProposalsQuery } from '../../../redux/d2cApiSlice'
import { proposalRow, inGroup, computeKpis } from '../apiMap'

export default function L1ApprovalQueue() {
  const navigate = useNavigate()
  const { data, isLoading, isError, error } = useListProposalsQuery({ page: 0, size: 100 })
  const rows = useMemo(() => {
    const mapped = Array.isArray(data) ? data.map(proposalRow).filter((r) => inGroup('l1Queue', r.apiStatus)) : []
    return [...mapped].sort((a, b) => new Date(b.raw?.updatedAt || 0) - new Date(a.raw?.updatedAt || 0)) // most recently changed first
  }, [data])
  const kpis = useMemo(() => computeKpis(data, 'l1-queue'), [data])

  const openReview = (r) => navigate(PATHS.l1Review, { state: { proposalId: r.proposalId, versionId: r.versionId, brand: r.brand, card: r.card, orderDataFileUri: r.orderDataFileUri, status: r.apiStatus } })
  const columns = [
    { key: 'brand', label: 'Brand', render: (r) => <b>{r.brand}</b> },
    { key: 'sl', label: 'Sales Leader' },
    { key: 'card', label: 'Card' },
    { key: 'band', label: 'Band' },
    { key: 'reason', label: 'Reason', render: (r) => <Pill label={r.reason} styleKey={r.whyKey} /> },
    { key: 'waiting', label: 'Waiting', align: 'right' },
    { key: 'sent', label: 'Last updated', align: 'right' },
    { key: 'a', label: 'Action', align: 'right', render: (r) => <ActionIconBtn title="Review" onClick={() => openReview(r)}><RateReviewOutlinedIcon fontSize="small" /></ActionIconBtn> },
  ]
  return (
    <Box sx={{ px: 3 }}>
      <PageTitle>Approval Queue</PageTitle>
      <KpiRow items={kpis} />
      {isLoading && <LinearProgress sx={{ my: 1 }} />}
      {isError && <Alert severity="error" sx={{ my: 1 }}>{error?.message || 'Failed to load the queue.'}</Alert>}
      <SectionCard title="Approval Queue" subtitle="Deals awaiting your review — all margins (L1 approval mandatory). 30-minute review promise.">
        <DataTable columns={columns} rows={rows} getRowKey={(r) => r.id} emptyText={isLoading ? 'Loading…' : 'Queue is clear'} />
      </SectionCard>
    </Box>
  )
}
